import { applyFunction } from '@intercom/pulse/lib/computed-properties';
import Ember from 'ember';

export default function htmlEscape(key) {
  return applyFunction(Ember.Handlebars.Utils.escapeExpression, key);
}
